
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  toc: true,
  layout: 'guide',
  description: 'Share consumer reports with approved partners using OAuth tokens'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='Sharing Consumer Report data with partners' subtitle='Share Consumer Report data with approved partners using OAuth tokens' mdxType="Header" />
    <h4 {...{
      "id": "overview"
    }}>{`Overview`}</h4>
    <p>{`For eligible product use cases, Plaid Check provides the ability to share Consumer Reporting Agency (CRA) report information with approved partners (Fannie Mae, Freddie Mac, or Experian) using OAuth. `}</p>
    <p>{`To share CRA report information with partners, you need to create an OAuth access token associated with a previously created `}<inlineCode parentName="p">{`user_id`}</inlineCode>{` that your partner can use to access the information.`}</p>
    <h4 {...{
      "id": "creating-an-oauth-token"
    }}>{`Creating an OAuth token`}</h4>
    <p>{`To create an access token that will be provided to your partner, call `}<inlineCode parentName="p">{`/oauth/token`}</inlineCode>{` following the example below.`}</p>
    <p>{`For the `}<inlineCode parentName="p">{`subject_token`}</inlineCode>{`, provide the `}<inlineCode parentName="p">{`user_id`}</inlineCode>{` that you created using `}<inlineCode parentName="p">{`/user/create`}</inlineCode>{`.`}</p>
    <p>{`The `}<inlineCode parentName="p">{`audience`}</inlineCode>{` must match the partner you are sharing with. Valid values are:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`urn:plaid:params:cra-partner:experian`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`urn:plaid:params:cra-partner:fannie-mae`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`urn:plaid:params:cra-partner:freddie-mac`}</inlineCode></li>
    </ul>
    <p>{`You can also provide multiple comma-separated values to create a token that will work with multiple partners. For example: `}<inlineCode parentName="p">{`"audience": "urn:plaid:params:cra-partner:experian,urn:plaid:params:cra-partner:fannie-mae"`}</inlineCode></p>
    <pre><code parentName="pre" {...{
        "className": "language-bash",
        "metastring": "switcher=false #/oauth/token request",
        "switcher": "false",
        "#/oauth/token": true,
        "request": true
      }}>{`curl 'https://sandbox.plaid.com/oauth/token' \\
--header 'Content-Type: application/json' \\
--data '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "grant_type": "urn:ietf:params:oauth:grant-type:token-exchange",
  "scope": "user:read",
  "subject_token_type":"urn:plaid:params:credit:multi-user",
  "audience": "urn:plaid:params:cra-partner:fannie-mae",
  "subject_token": "usr_9nSp2KuZ2x4JDw"
}'
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-bash",
        "metastring": "switcher=false #/oauth/token response",
        "switcher": "false",
        "#/oauth/token": true,
        "response": true
      }}>{`{
  "access_token": "pda-RDdg0TUCB0FB25_UPIlnhA==",
  "expires_in": 2591999,
  "refresh_token": "Rpdr--viXurkDg88d5zf8m6Wl0g==",
  "request_id": "vPamXI8hYXPl7P2",
  "token_type": "Bearer"
}
`}</code></pre>
    <p>{`You can then provide the `}<inlineCode parentName="p">{`access_token`}</inlineCode>{` to your partner.`}</p>
    <h4 {...{
      "id": "revoking-an-oauth-token"
    }}>{`Revoking an OAuth token`}</h4>
    <p>{`To revoke your token, call `}<inlineCode parentName="p">{`/oauth/revoke`}</inlineCode>{`, passing in the `}<inlineCode parentName="p">{`access_token`}</inlineCode>{` and/or `}<inlineCode parentName="p">{`refresh_token`}</inlineCode>{` as the `}<inlineCode parentName="p">{`token`}</inlineCode>{` value.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash",
        "metastring": "switcher=false #/oauth/revoke request",
        "switcher": "false",
        "#/oauth/revoke": true,
        "request": true
      }}>{`curl -X POST https://sandbox.plaid.com/oauth/revoke \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "token": "pda-RDdg0TUCB0FB25_UPIlnhA=="
}'
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-bash",
        "metastring": "switcher=false #/oauth/revoke response",
        "switcher": "false",
        "#/oauth/revoke": true,
        "response": true
      }}>{`{
  "request_id": "pCDVCQK8ve2MzhM"
}
`}</code></pre>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "overview",
        level: 4,
        title: "Overview",
      },
{
        id: "creating-an-oauth-token",
        level: 4,
        title: "Creating an OAuth token",
      },
{
        id: "revoking-an-oauth-token",
        level: 4,
        title: "Revoking an OAuth token",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
